import { observer } from 'mobx-react-lite';

import { Button, PopupFooter } from '@gem/ui-kit';

import { SelectWorkspaceMembers } from '../../../components/SelectWorkspaceMembers/SelectWorkspaceMembers';
import {
  IParticipantSelectListPresenterParams,
  useParticipantSelectList,
} from './ParticipantSelectList.presenter';

export type IParticipantSelectListParams = IParticipantSelectListPresenterParams;

export const ParticipantSelectList = observer(
  ({ onSuccess, group }: IParticipantSelectListParams) => {
    const presenter = useParticipantSelectList({ onSuccess, group });

    return (
      <>
        <SelectWorkspaceMembers
          selectedMembersIds={presenter.selectedParticipantIds}
          setSelectedIds={presenter.setSelectedIds}
          groupId={group.id}
          targetGroupType={group.type}
        />
        <PopupFooter>
          <Button
            isLoading={presenter.isSubmitting}
            isDisabled={presenter.isAddButtonDisabled}
            onClick={presenter.addParticipants}
            theme="primary"
          >
            {presenter.buttonText}
          </Button>
        </PopupFooter>
      </>
    );
  }
);
